import APanel from '../ScreenComponents/APanel';
import * as StyleFunctions from '../utilities/StyleFunctions';
import React, {useRef} from 'react';

function App(props) {

  var sStyle = props.sStyle;
  var insetWidth = props.insetWidth;
  var path = props.path;
  var inputValues = props.inputValues;
  var setInputValues = props.setInputValues;
  var alertVisibility = props.alertVisibility;
  var internalVariablesHere = props.internalVariablesHere;
  var upwardInfo = props.upwardInfo;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var getRef1 = props.getRef1;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var setIsClickingOnContentDivHere = props.setIsClickingOnContentDivHere;  
  var currentListA = props.currentListA;
  var insetHeight = props.insetHeight;
  var interactionFn = props.interactionFn;
  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var isError = props.isError;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var ownVariables = props.ownVariables;
  var doAScreenRef = props.doAScreenRef;
  var refObject = props.refObject;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var pPiece = props.pPiece;
  var clickItemOut = props.clickItemOut;
  var chains = props.chains;
  var lastEdited = props.lastEdited;

  var pageRef = useRef();
  var bRef = useRef();

  var overallS = {};
  if (currentListA.s){
    overallS = StyleFunctions.evaluateStyleR('DAPP', currentListA.s, ['s'], currentListA, internalVariablesHere, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  }
  if (!overallS.color){
    overallS.color = 'black';
  }

  // console.log(sStyle);
  // console.log(insetWidth/overallWidth);
  // console.log(insetWidth);
  // console.log(overallWidth);
  // var scale = 1;
  var relativeSize = 0.4 * 0.9;
  // var relativeSize = insetWidth / (overallWidth);

        var offsetTop1 = 0;
      var offsetLeft1 = 0;

      if (pageRef && pageRef.current && bRef && bRef.current){
        offsetTop1 = (pageRef.current.offsetTop + 15) / sStyle.msZoom;
        offsetLeft1 =  ((pageRef.current.offsetLeft 
            + 5 
            // + overallWidth * 0.05   
            + bRef.current.offsetLeft
          ) / sStyle.msZoom) ; 
      }

      // console.log(insetWidth);
      // console.log(insetWidth * sStyle.msZoom);
      // console.log(overallWidth);
      // console.log(overallWidth * 0.4);

      // console.log(offsetTop1);
      // console.log(offsetLeft1);
      // sStyle.border = '1px solid red';

 // style={{border:'1px solid red'}}
  return <div className='col-6' ref={pageRef}><div className='checkboard' style={{border:'', padding:'5px', marginTop:'10px', cursor:'pointer'}} onClick={clickItemOut}><div style={sStyle} ref={bRef}><APanel lastEdited={lastEdited} chains={chains} relativeSize={relativeSize} actualWidth={insetWidth} panelPath={path} style={overallS} inputValues={inputValues} setInputValues={setInputValues} alertVisibility={alertVisibility} insetWidth={insetWidth}  currentList={currentListA} organicChanges={organicChanges} userNos={userNos} userID={userID} itemEdited={itemEdited} setItemEdited={setItemEdited} onClickItemChangeSelection={onClickItemChangeSelection} internalVariables={internalVariablesHere} refObject={refObject} getRef1={getRef1} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} error={isError} insetHeight={insetHeight} interactionFn={interactionFn} setIsShowingSomeDropDown={setIsShowingSomeDropDown} isShowingSomeDropDown={isShowingSomeDropDown} setIsClickingOnContentDiv={setIsClickingOnContentDivHere} isClickingOnContentDiv={isClickingOnContentDiv} doAScreenRef={doAScreenRef} addWhereText={''} potentiallyAddWhichItem={potentiallyAddWhichItem} actHoveringWhere={actHoveringWhere} hoveringWhere={hoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} hidePanelRelativeItems={{}} flashHighlight={false} changeTab={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} offsetTop={offsetTop1} offsetLeft={offsetLeft1} counter={0}/></div>{pPiece}
      </div></div>
//


}


//
export default App;
